// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"28ccd21d","239":"c672f068","488":"b9d9d5a7","732":"98ea7837"}[chunkId] + ".chunk.js";
};